import { Component, OnInit, TemplateRef } from '@angular/core';
import { UserModel } from 'src/app/model/user.model';
import { UserService } from 'src/app/service/user.service';
import { UsersPolicyService } from 'src/app/service/users-policy.service';
import swal from 'sweetalert2';
import { SecurityService } from 'src/app/service/security.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AttributeModel } from '../dynamic/model/attribute.model';
import { UsersPolicyModel } from 'src/app/model/users-policy.model';
import { AuthenticationService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  modalRef: BsModalRef
  p: number = 1;

  policies: AttributeModel[]
  users: Array<UserModel>
  model: UserModel
  newUser: boolean
  initialState: UserModel
  showEdition: boolean
  roles: any[] = []
  units: any[] = []
  selectedRoles: string[] = []
  selectedUnits: string[] = []
  phone: string
  term: string
  loadingRoles: boolean = false;
  loadingUnits: boolean = false;
  usersPolicyServiceData: UsersPolicyModel;

  constructor(
    private authService: AuthenticationService,
    private usersPolicyService: UsersPolicyService,
    private userService: UserService,
    private securityService: SecurityService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService) {
      this.users = []
      this.showEdition = false
      this.newUser = false
  }

  get isAdminUser(): boolean {
    return this.authService.hasRole("admin")
  }

  get hasPermitionToAdd(): boolean {
    return this.authService.hasRole("add-users")
  }

  get hasPermitionToEdit(): boolean {
    return this.authService.hasRole("edit-users")
  }

  get hasPermitionToViewLoginHistory(): boolean {
    return this.authService.hasRole("UserAccessHistoryViewer")
  }

  ngOnInit() {
    this.usersPolicyService
      .getPolicy()
      .subscribe(data => {
        if(data) {
          this.usersPolicyServiceData = data;
          this.policies = data.attributes
          this.roles = data.attributes
            .filter(attr => attr.key.toLowerCase() == "roles")[0]
            .attributes
            .map(role => {
              return {
                id: role.key,
                name: role.value
              }
            })

          let unidades = data.attributes
            .filter(attr => attr.key.toLowerCase() == "unidades")[0]

          if(unidades) {
            this.units = unidades.attributes
              .map(unidade => {
                return {
                  id: unidade.key,
                  name: unidade.value
                }
              })
          }
        }
      });

    this.loadUsers()
  }

  addNewRole = (name:string) => {
    this.loadingRoles = true;
    return new Promise((resolve) => {
      let id = name.toLowerCase().replace(/ /g, '-');
      this.usersPolicyServiceData.attributes.find(e => e.key.toUpperCase() === 'ROLES').attributes.push({
        attributes: [],
        key: id,
        options: [],
        postEvents: [],
        type: 'option',
        value: name
      });

      this.usersPolicyService.setPolicy(this.usersPolicyServiceData).subscribe(data => {
        this.roles.push({ id: id, name: name});
        resolve({ id: id, name: name});
        this.loadingRoles = false;
      });
    })
  }

  addNewUnit = (name:string) => {
    this.loadingUnits = true;
    return new Promise((resolve) => {
      let id = name.toLowerCase().replace(/ /g, '-');
      this.usersPolicyServiceData.attributes.find(e => e.key.toUpperCase() === 'UNIDADES').attributes.push({
        attributes: [],
        key: id,
        options: [],
        postEvents: [],
        type: 'option',
        value: name
      });

      this.usersPolicyService.setPolicy(this.usersPolicyServiceData).subscribe(data => {
        this.roles.push({ id: id, name: name});
        resolve({ id: id, name: name});
        this.loadingUnits = false;
      });
    })
  }



  addNewUser(template: TemplateRef<any>) {
    this.reset()
    this.model = new UserModel()
    this.model.userType = "Internal"
    this.initialState = JSON.parse(JSON.stringify(this.model))
    this.showEdition = true
    this.newUser = true
    window.scroll(0, 0)
    this.openModal(template)
  }

  cancel() {
    this.reset()
    this.modalRef.hide()
  }

  changePasswordRequest() {
    this.spinner.show();
    this.securityService
      .requestPasswordChange(this.model.userName)
      .subscribe(() => {
        this.spinner.hide();
        this.modalRef.hide();
        swal.fire("Sucesso", `Um e-mail foi enviado para ${this.model.email} com o link para alteração de senha.`, "success");
      })
  }

  delete() {
    this.spinner.show();
    this.securityService.deleteUser(this.model.id).subscribe(() => {
      this.spinner.hide();
      this.modalRef.hide();
      this.loadUsers();
      swal.fire("Sucesso", `O usuário ${this.model.email} foi excluído com sucesso.`, "success");
    });
  }

  reset() {
    this.newUser = false
    // this.showEdition = false
    this.model = this.initialState
    this.selectedRoles = []
    this.selectedUnits = []
  }

  loadUsers() {
    this.spinner.show();
    this.userService
      .getAllUsers()
      .subscribe(retorno => {
        this.users = retorno.sort((a, b) =>
          a.userName.toLowerCase() < b.userName.toLowerCase() ? -1 : 1)
        this.userService.requestChanged.emit(false)
        this.spinner.hide();
      })
  }

  inactivate() {
    this.spinner.show();
    this.securityService.patchWithComplement(`Users/${this.model.id}/SwitchActivation`, null).subscribe(() => {
      this.spinner.hide();
      this.modalRef.hide();
      swal.fire("Sucesso", `O usuário ${this.model.email} foi ${this.model.inactive ? "ativado" : "inativado" } com sucesso.`, "success");
    });
  }

  selectUser(user: UserModel, template: TemplateRef<any>) {
    this.reset()
    this.initialState = JSON.parse(JSON.stringify(user))
    this.model = user

    if(this.model.roles) {
      this.selectedRoles = this.model.roles
      this.selectedRoles.forEach(role => {
        if(this.roles.every(r => r != role)) {
          this.roles.push(role)
        }
      })
    }

    if(this.model.attributes) {
      let unidades = this.model.attributes
        .filter(attr => attr.key.toLowerCase() == "unidades")[0]

      if(unidades) {
        this.selectedUnits = unidades.attributes
          .map(unidade => unidade.key)
      }

      let phone = this.model.attributes
        .find(attr => attr.key.toLowerCase() == "telefone")

      if(phone) {
        this.phone = phone.value
      }
    }

    this.showEdition = true
    this.openModal(template)
    window.scroll(0, 0)
  }

  onSubmit() {
    swal.fire({
      title: 'Atenção',
      text: 'Deseja salvar o usuário?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim'
    }).then((result) => {
      if (result.value) {
        // swal.showLoading()
        this.spinner.show();
        this.save()
      }
    })
  }

  save() {
    this.model.roles = this.selectedRoles

    if(!this.model.attributes) {
      this.model.attributes = []
    }

    let unidades = this.model.attributes
      .find(attr => attr.key.toLowerCase() == "unidades")

    if(!unidades) {
      unidades = new AttributeModel()
      unidades.key = "Unidades"
      unidades.type = "collection"
      this.model.attributes.push(unidades)
    }

    unidades.attributes = this.selectedUnits.map(unit => {
      return {
        key: unit,
        value: unit,
        type: "option"
      }
    })

    let phone = this.model.attributes
      .find(attr => attr.key.toLowerCase() == "telefone")

    if(!phone) {
      phone = new AttributeModel()
      phone.key = "Telefone"
      phone.type = "Text"
      this.model.attributes.push(phone)
    }

    phone.value = this.phone

    this.securityService
      .saveUser(this.model, 10, 3)
      .subscribe(() => {
        this.modalRef.hide()
        this.loadUsers()
        this.reset()
      }, (error) => {
        swal.fire('Ocorreu um erro', error, 'error');
      })
  }

  private openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'right'});
  }

  closeModal() {
    this.modalRef.hide()
  }
}
